export const TriggerContext = {
  AdminPanel: 'admin',
  ProDashboard: 'dashboard',
};
